import abTests from '@/js/common/Domain/Service/abTests';

export default (tourProducts, productType = 'TourProduct') => {
    if (!tourProducts?.length) return [];
    const isBedsMergeEnabled = abTests.hasTest('IN-5314');
    return _.values(tourProducts.reduce((group, productData) => {
        if (productData.get('type') !== productType && productType !== 'all') {
            return group;
        }

        const product = productData.get('product');
        const nights = product.get('nights');
        const nightsInHotel = product.get('nightsInHotel') !== undefined ? product.get('nightsInHotel') : nights;
        const date = product.get('startDate');
        const meal = product.get('meal').get('id');
        const room = product.get('room');
        const operator = product.get('operator');
        const roomCategory = room.category || `${operator.id}_${room.name}`;
        const tourKey = `${nights}_${nightsInHotel}_${date}_${meal}_${roomCategory}`;

        const productTypeToMerge = productData.get('type');
        const isBedsMergeAllowedForType = productTypeToMerge === 'TourProduct' || productTypeToMerge === 'HotelOfferProduct';
        if (isBedsMergeEnabled && isBedsMergeAllowedForType) {
            if (group[tourKey]) {
                group[tourKey].push(productData);
            } else {
                group[tourKey] = [productData];
            }
            return group;
        }

        if (group[`${tourKey}_${room.beds}`]) {
            group[`${tourKey}_${room.beds}`].push(productData);
        } else {
            group[`${tourKey}_${room.beds}`] = [productData];
        }

        if (group[`${tourKey}_null`] && room.beds && productType !== 'HotelOfferProduct') {
            group[`${tourKey}_null`].push(productData);
        }

        return group;
    }, {}));
};
